module.exports = __webpack_public_path__ + "static/media/vertical_timeline.38fa6d84.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/StartupTimeline/assets/vertical_timeline.png
// module id = 545
// module chunks = 0